import { createContext } from 'react';

const PoliciesContext = createContext();

export default PoliciesContext;
